import { ApiClientError } from '@/lib/http-core';

/**
 * 상품 저장(등록·수정)이 BE 에서 거절됐을 때, 그 원인이 폼의 어느 칸인지. 칸을 알면 폼이 그 칸으로 옮겨 가고
 * 칸 아래에 사유를 보여 준다(위쪽 배너만으로는 어디를 고칠지 찾기 어려웠다).
 *
 * - artist: 비활성(ARCHIVED) 아티스트 연결 — CATALOG_ARTIST_ARCHIVED(409). 이관 상품이 보관된 아티스트를
 *   물고 있으면 본문 정렬만 고쳐 저장해도 이 사유로 막힌다.
 */
export type ProductServerField = 'artist';

export interface ProductServerFieldError {
  field: ProductServerField;
  message: string;
}

const ARTIST_CODES = new Set(['CATALOG_ARTIST_ARCHIVED', 'CATALOG_ARTIST_NOT_FOUND', 'CATALOG_ARTIST_VENDOR_MISMATCH']);

export const productServerFieldError = (err: unknown): ProductServerFieldError | null => {
  if (!err) return null;
  const code = err instanceof ApiClientError ? String(err.code) : (err as { code?: unknown }).code;
  const message = err instanceof Error ? err.message : '';
  // 코드가 일반 CONFLICT 로 올 때도 있어(전역 핸들러) 메시지로도 판정한다.
  if ((typeof code === 'string' && ARTIST_CODES.has(code)) || /아티스트는 상품에 연결할 수 없습니다/.test(message)) {
    return { field: 'artist', message };
  }
  return null;
};
